import React from "react";
import { Link } from "react-router-dom";
import { Gift, UtensilsCrossed, ChevronRight, Award } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const HERO = "https://c40fa55c-f92b-45b2-83f1-1fe2372f818.vercel.app/images/uploads/789c2f85-f63a-44f2-8305-e949c0059177.png";
const CATERING_IMG = "https://c40fa55c-f92b-45b2-83f1-1fe2372f818.vercel.app/images/generated/exquisite-serbian-sarma-tender.png";

const Home = () => {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl mx-auto px-4 pt-20 pb-24">
      {user && <p className="text-[#9a4a2f] font-heading text-lg font-semibold">Hello, {user.first_name}</p>}

      {/* Hero */}
      <div className="relative mt-2 rounded-3xl overflow-hidden shadow-xl">
        <img src={HERO} alt="Chef Mila" className="w-full h-[380px] object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
        <div className="absolute bottom-0 p-6 text-white">
          <h1 className="font-heading text-4xl font-bold">Welcome to TABLE24</h1>
          <p className="mt-2 text-white/90 max-w-md">Hearty homemade European meals — fresh every weekday. Order for pickup and earn rewards.</p>
          <Link to="/menu" className="mt-4 inline-flex rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold px-6 py-3 transition-colors">Order Now</Link>
        </div>
      </div>
      <Link to="/menu" className="mt-3 block text-center rounded-xl bg-[#efe3cd] hover:bg-[#e6d6b8] text-[#4a3524] font-semibold py-3 transition-colors">View Menu</Link>

      {/* Catering card */}
      <Link to="/catering" className="mt-4 block rounded-3xl overflow-hidden shadow-lg relative group">
        <img src={CATERING_IMG} alt="Catering" className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/20" />
        <div className="absolute inset-0 p-5 flex flex-col justify-center text-white">
          <span className="text-xs font-semibold tracking-wider uppercase text-[#f0c9a8]">Catering</span>
          <h3 className="font-heading text-2xl font-bold mt-1">Catering for your event</h3>
          <p className="text-sm text-white/85">Packages for 10, 20, 50 or build your own.</p>
          <span className="mt-2 inline-flex items-center gap-1 text-sm font-semibold">Explore catering <ChevronRight className="h-4 w-4" /></span>
        </div>
      </Link>

      {/* Rewards explainer */}
      <div className="mt-4 rounded-3xl bg-[#f7e4df] p-5">
        <div className="flex items-center gap-2 text-[#9a4a2f] font-semibold"><Gift className="h-5 w-5" /> Rewards Program</div>
        <p className="text-sm text-[#6b5844] mt-1">Order delicious homemade meals and earn rewards! You get 1 point for every meal.</p>
        <div className="mt-3 divide-y divide-[#e9c9c0]">
          <div className="flex justify-between py-2"><span className="text-[#9a4a2f] font-bold">10 pts</span><span className="text-[#6b5844]">FREE dessert</span></div>
          <div className="flex justify-between py-2"><span className="text-[#9a4a2f] font-bold">15 pts</span><span className="text-[#6b5844]">Mixed sweets box</span></div>
        </div>
      </div>

      {/* How it works */}
      <div className="mt-4 rounded-3xl bg-[#f6ece0] p-5">
        <div className="flex items-center gap-2 text-[#2c1e12] font-semibold"><UtensilsCrossed className="h-5 w-5 text-[#9a4a2f]" /> How it works</div>
        <ol className="mt-2 space-y-1.5 text-sm text-[#6b5844] list-decimal list-inside">
          <li>Browse the weekly menu (Mon–Fri)</li>
          <li>Add your favourite meals to the cart</li>
          <li>Place your order for pickup or delivery</li>
          <li>Earn points and redeem free treats</li>
        </ol>
        <p className="mt-3 text-xs text-[#9a4a2f] flex items-center gap-1"><Award className="h-4 w-4" /> Order the day before — last call 10 PM.</p>
      </div>
    </div>
  );
};

export default Home;
